import { Component } from 'preact';

import handleLoadingAndError from '../handle-loading-and-error';

/**
 * The ObservationsPanelGraph component wraps the panel graph functionality,
 * providing options to select different parameter views.
 *
 * props:
 * - view: The panelgraph view to render (see GRAPH_VIEW enum). Defaults to COMBINED
 * - data: The dataset to render in the panelgraph
 */

class ObservationsPanelGraph extends Component {

	constructor(props, context) {
		super(props, context);

		this.units = context.userSettings.units;
		this.graphContainer = null;
		this.graphContainerWidth = -1;
		this.graph = null;
	}

	updateGraph(props) {
		this.graph = props.factory(props.data, this.units, props.view, this.graphContainerWidth);
		this.graph.render(this.graphContainer);
	}

	componentDidMount() {

		this.graphContainerWidth = this.graphContainer.getBoundingClientRect().width;

		this.updateGraph(this.props);

		this.resizeHandlerId = this.context.resize.addHandler(() => {

			const width = this.graphContainer.getBoundingClientRect().width;

			// Only re-render the graph if the container width has actually changed.
			if (width !== this.graphContainerWidth) {
				this.graphContainerWidth = width;
				this.updateGraph(this.props);
			}

		});

		// Create a touch handler on document which will hide the tooltips if an element
		// that is not the chart event capturing box is touched. This is to handle the case
		// on touch devices where no mouseout event is fired and in some cases no blur event
		// is fired either.
		this.documentTouchHandler = evt => {
			if (evt.target !== this.graph.eventCapturingBox) {
				this.graph.hideTooltips();
			}
		};

		document.addEventListener('touchstart', this.documentTouchHandler);

		if (typeof this.props.mounted === 'function') {
			this.props.mounted();
		}
	}

	componentWillUnmount() {
		this.context.resize.removeHandler(this.resizeHandlerId);

		document.removeEventListener('touchstart', this.documentTouchHandler);
	}

	componentWillReceiveProps(nextProps) {
		this.updateGraph(nextProps);
	}

	shouldComponentUpdate() {
		return false;
	}

	render() {
		return (
			<div class="hw_panel_graph" ref={el => { this.graphContainer = el; }} />
		);
	}

}

export default handleLoadingAndError(ObservationsPanelGraph);



// WEBPACK FOOTER //
// ./components/observations-panelgraph/index.js